import { useApiPrivateRequest } from "@/shared/hooks/useApi";

export const useUploadDocumentByUrl = () => {
  const { call, isLoading, isFailed } = useApiPrivateRequest<string>(
    (response) => response.id,
  );

  const uploadDocument = async (url: string) => {
    return await call("/documents/url", "POST", undefined, {
      url,
    });
  };

  return { uploadDocument, isLoading, isFailed };
};
